<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="city_box flex Flexjustify">
      <div class="city_container">
        <div class="city_select flex Flexalign">
          <div class="select_text">按省份选择：</div>
          <el-select v-model="provinceValue" clearable placeholder="省份" size="large"
            style="width: 140px; height: 40px; margin-left: 15px" no-match-text="暂无省份列表" @change="changeProvinceValue">
            <el-option v-for="item in provinceList" :key="item.provinceId" :label="item.provinceName"
              :value="item.provinceId" />
          </el-select>
          <el-select v-model="cityValue" clearable placeholder="城市" size="large"
            style="width: 140px; height: 40px; margin-left: 15px" no-data-text="暂无城市列表" no-match-text="暂无城市列表" @change="changeCityValue">
            <el-option v-for="item in citySelectList" :key="item.cityId" :label="item.cityName" :value="item.cityId" />
          </el-select>
          <div class="select_text search_text">直接搜索：</div>
          <div class="top_input_box">
            <!-- <el-input v-model="selectCityInfo.cityName" style="max-width: 600px" placeholder="请输入城市名" class="input-with-select">
              <template #append>
                <div class="btn_search">搜索</div>
              </template>
</el-input> -->
            <el-select v-model="inputCityValue" clearable filterable placeholder="请输入城市名" no-match-text="未搜到该城市" style="width: 160px"
              @change="changeInputCityValue">
              <el-option v-for="item in citySearchList" :key="item.cityId" :label="item.cityName"
                :value="item.cityId" />
            </el-select>
          </div>
          <div class="btn_confirm mar_left_20 cursor_pointer" @click="confirmCity">确定</div>
        </div>
        <div class="city_select flex Flexalign hot_city">
          <div class="select_text">热门城市：</div>
          <div class="flex-1 flex FlexAround">
            <div class="hot_city_text cursor_pointer" v-for="(item, index) in hotCityList"
              :class="[item.cityId == selectCityInfo.cityId ? 'active_city' : '']" :key="index"
              @click="selectCity(item)">
              {{ item.cityName }}
            </div>
          </div>
        </div>
        <div class="city_select hot_city border_none">
          <div class="select_text">按省份字母选择：</div>
          <div class="city_all flex flexcolumn">
            <div class="" v-for="(item, index) in cityList" :key="index">
              <div class="flex FlexWrap city_one" v-if="item.provinceList.length">
                <div class="city_letter Flexalign flex flexcolumn Flexjustify"
                  :class="[index != 0 ? 'border_top_none' : '']">
                  {{ item.letter }}
                </div>
                <div class="province_list flex-1">
                  <div class="province_box flex flexcolumn" v-for="(sitem, sindex) in item.provinceList" :key="sindex">
                    <div class="flex">
                      <div class="province_name flex flexcolumn Flexjustify"
                        :class="[(index != 0 || sindex != 0) ? 'border_top_none' : '']">
                        {{ sitem.name }}
                      </div>
                      <div class="flex-1 FlexWrap flex Flexalign city_all_box"
                        :class="[(index != 0 || sindex != 0) ? 'border_top_none' : '']">
                        <div class="city_name cursor_pointer" v-for="(ssitem, ssindex) in sitem.list" :key="ssindex"
                          :class="[ssitem.cityId == selectCityInfo.cityId ? 'active_city' : '']"
                          @click="selectCity(ssitem)">
                          {{ ssitem.cityName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
import area from '@/assets/data/area';
import pinyin from 'pinyin';
export default {
  name: "GjkcH5Index",

  data() {
    return {
      provinceValue: "",
      cityValue: '',
      inputCityValue: '',
      citySelectList: [],
      citySearchList: [],
      provinceList: [],
      hotCityList: [],
      cityList: [],
      selectCityInfo: {
        cityId: '',
        cityName: ''
      }
    };
  },

  mounted() {
    this.getHotCityList();
    this.arrangeCityByFirstLetter();
    this.getProvinceList();
    this.getCitySearchList();
  },
  watch: {
    provinceValue(value) {
      this.cityValue = '';
      this.citySelectList = this.$Tools.getCityByProvinceId(value);
    },
  },

  methods: {
    // 省改变恢复输入的城市
    changeProvinceValue() {
      this.inputCityValue = '';
    },
    changeCityValue() {
      for (let key in area.city_list) {
        if (key == this.cityValue) {
          this.selectCityInfo.cityId = key;
          this.selectCityInfo.cityName = area.city_list[key];
        }
      }
      this.getHotCityList();
      this.arrangeCityByFirstLetter();
    },
    // 输入的城市改变恢复省市下拉框
    changeInputCityValue() {
      this.provinceValue = '';
      this.cityValue = '';
      for (let key in area.city_list) {
        if (key == this.inputCityValue) {
          this.selectCityInfo.cityId = key;
          this.selectCityInfo.cityName = area.city_list[key];
        }
      }
      this.getHotCityList();
      this.arrangeCityByFirstLetter();
    },
    selectCity(info) {
      this.provinceValue = '';
      this.cityValue = '';
      this.inputCityValue = '';
      this.selectCityInfo = info;
      this.confirmCity();
    },
    confirmCity() {
      this.$store.commit('area/setReady', this.selectCityInfo);
      this.$Jump.back();
    },
    // 获取市列表
    getCitySearchList() {
      for (let key in area.city_list) {
        this.citySearchList.push({ cityId: key, cityName: area.city_list[key] });
      }
    },
    // 获取省份
    getProvinceList() {
      for (let key in area.province_list) {
        this.provinceList.push({ provinceId: key, provinceName: area.province_list[key] });
      }
    },
    // 获取热门城市
    getHotCityList() {
      this.hotCityList = [];
      for (let key in area.hot_city_list) {
        this.hotCityList.push({ cityId: key, cityName: area.hot_city_list[key] });
      }
    },
    // 汉字获取拼音首字母
    getChineseInitial(chineseText) {
      // 使用 pinyin 库转换中文为拼音
      const pinyinArray = pinyin(chineseText, {
        style: pinyin.STYLE_FIRST_LETTER, // 设置转换风格为首字母
        heteronym: false // 不考虑多音字
      });

      // 提取每个中文字符的首字母并连接成一个字符串
      return pinyinArray.flat().join('').toUpperCase();
    },
    // 将城市按照省份首字母进行划分
    arrangeCityByFirstLetter() {
      this.cityList = [];
      for (let i = 0; i < 26; i++) {
        let provinceList = [];
        // 遍历出该字母的省份
        for (let key in area.province_list) {
          if (String.fromCharCode(65 + i) == this.getChineseInitial(area.province_list[key]).slice(0, 1)) {
            let cityList = [];
            // 遍历出省份下的城市
            for (let cityKey in area.city_list) {
              let proinceSign = key.slice(0, 2);
              let citySign = cityKey.slice(0, 2);
              if (proinceSign == citySign) {
                cityList.push({
                  cityId: cityKey,
                  cityName: area.city_list[cityKey]
                })
              }
            }
            provinceList.push({ name: area.province_list[key], list: cityList })
          }
        }
        this.cityList.push({
          letter: String.fromCharCode(65 + i),
          provinceList: provinceList
        })
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.city_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;
  padding-top: 30px;
  box-sizing: border-box;

  .city_container {
    width: $pageMainWidth;
    // height: 933px;
    background: #ffffff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;

    .city_select {
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(36, 35, 36, 0.1);

      .select_text {
        font-size: 18px;
        color: #111111;
      }

      .search_text {
        margin-left: 50px;
      }

      .top_input_box {
        :deep(.el-select__wrapper.is-filterable) {
          height: 44px;
        }

        :deep(.el-input-group__append),
        .el-input-group__prepend {
          padding: 0;
          border-radius: 0px 10px 10px 0px;
        }

        :deep(.el-input__wrapper) {
          border-radius: 10px 0px 0px 10px;
        }

        :deep(.el-input__inner) {
          color: #666666;
        }

        .btn_search {
          text-align: center;
          line-height: 44px;
          width: 67px;
          height: 44px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 0px 10px 10px 0px;
          color: #ffffff;
        }
      }

      .btn_confirm {
        border-radius: 10px;
        width: 90px;
        height: 44px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        color: #ffffff;
        line-height: 44px;
        text-align: center;
      }
    }

    .hot_city {
      padding-top: 20px;

      .hot_city_text {
        font-size: 16px;
        color: #111111;
      }

      .active_city {
        color: #13d6aa;
      }

      .city_all {
        margin: 28px 0;

        .city_one {

          //   width: 100%;
          .city_letter {
            width: 42px;
            background: #f4f4f4;
            border-top: 1px solid #ededed;
            border-left: 1px solid #ededed;
            border-bottom: 1px solid #ededed;
          }

          .border_top_none {
            border-top: none;
          }

          .province_list {
            .province_name {
              // padding: 0 20px;
              width: 100px;
              text-align: center;
              height: 54px;
              border-top: 1px solid #ededed;
              border-left: 1px solid #ededed;
              border-bottom: 1px solid #ededed;
            }

            .city_all_box {
              border: 1px solid #ededed;
            }

            .border_top_none {
              border-top: none;
            }

            .city_name {
              margin: 0 9px;
            }

            .active_city {
              color: #13d6aa;
            }
          }
        }
      }
    }

    .border_none {
      border: none;
    }
  }
}
</style>